export default __webpack_public_path__ + "static/media/area.54cd209c.jpg";